const getHeaders = (userType, reportType, headers) => {
  const customHeaders = {
    PRO: {
      BILLS: [
        {
          selector: "billNumber",
          name: `# ${headers.bill}`,
        },
        {
          selector: "status",
          name: headers.paymentType,
        },
        {
          selector: "statusType",
          name: headers.billStatus,
        },
        {
          selector: "cedJuridica",
          name: headers.idClient,
        },
        {
          selector: "companyName",
          name: headers.clientName,
        },
        {
          selector: "fechaCarga",
          name: headers.loadDate,
        },
        {
          selector: "fechaEmision",
          name: headers.emissionDate,
        },
        {
          selector: "fechaVencimiento",
          name: headers.dueDate,
        },
        {
          selector: "mount",
          name: headers.amount,
        },
      ],
    },
    BSC: {
      BILLS: [
        {
          selector: "billNumber",
          name: `# ${headers.bill}`,
        },
        {
          selector: "statusType",
          name: headers.billStatus,
        },
        {
          selector: "cedJuridica",
          name: headers.providerId,
        },
        {
          selector: "companyName",
          name: headers.providerName,
        },
        {
          selector: "cif",
          name: headers.cif,
        },
        {
          selector: "fechaCarga",
          name: headers.loadDate,
        },
        {
          selector: "fechaEmision",
          name: headers.emissionDate,
        },
        {
          selector: "fechaVencimiento",
          name: headers.dueDate,
        },
        {
          selector: "mount",
          name: headers.amount,
        },
      ],
    },
    CSA: {
      PROVIDERS: [
        {
          selector: "name",
          name: headers.providerName,
          bodyStyle: { overflowWrap: "anywhere" },
        },
        {
          selector: "businessId",
          name: headers.providerId,
          bodyStyle: { overflowWrap: "anywhere" },
        },
        {
          selector: "relationType",
          name: headers.typeRelation,
        },
        {
          selector: "state",
          name: headers.stateRelation,
        },
        {
          selector: "account",
          name: headers.numberAccountPayment,
          bodyStyle: { overflowWrap: "anywhere" },
        },
        {
          selector: "currency",
          name: headers.currency,
        },
      ],
    },
    PROVIDERS: [
      {
        selector: "name",
        name: headers.providerName,
      },
      {
        selector: "businessId",
        name: headers.providerId,
      },
      {
        selector: "type",
        name: "Tipo de Proveedor",
      },
      {
        selector: "billAmount",
        name: headers.bill,
      },
      {
        selector: "contact",
        name: headers.contact,
      },
      {
        selector: "email",
        name: "Correo",
      },
      {
        selector: "state",
        name: headers.state,
      },
      {
        selector: "invitationStatus",
        name: "Estado Invitaciones",
      },
    ],
    BILLS: [
      {
        selector: "billNumber",
        name: headers.billNumber,
      },
      {
        selector: "statusType",
        name: headers.billStatus,
      },
      {
        selector: "companyName",
        name: headers.providerName,
      },
      {
        selector: "relationType",
        name: "Tipo de relación del Proveedor",
      },
      {
        selector: "fechaCarga",
        name: headers.loadDate,
      },
      {
        selector: "fechaVencimiento",
        name: headers.dueDate,
      },
      {
        selector: "mount",
        name: headers.amount,
      },
      {
        selector: "isH2h",
        name: headers.isH2h,
      },
    ],
    CUSTOMERS: [
      {
        selector: "cif",
        name: "CIF",
      },
      {
        selector: "name",
        name: headers.name,
      },
      {
        selector: "country",
        name: headers.country,
      },
      {
        selector: "identification",
        name: headers.id,
      },
      {
        selector: "status",
        name: headers.state,
      },
    ],
  };

  return customHeaders[userType] !== undefined &&
    customHeaders[userType][reportType] !== undefined
    ? customHeaders[userType][reportType]
    : customHeaders[reportType];
};

export default getHeaders;
